import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import imgRetroalimentacionAltoVolumenPronostico from "../../assets/img-caso/img-1.jpg";
import NextButton from "../../components/NextButton";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { IconLaurelWreath } from "@tabler/icons-react";

function Scenario5Fin({ intl }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const activeScenario = getScenarioNumByPath(location.pathname);

  return (
    <div className="h-100">
      <div className="container-fluid h-100">
        <div className="row h-100">
          <div
            className="col-md-12 d-flex justify-content-start align-items-center px-5 pt-5"
            style={{ marginBottom: "2vh" }}
          >
            <div className="d-flex flex-column align-items-start w-100">
              <h3 className="txt42 txt-purple bold w-100 mb-4 position-relative">
                ¡Felicidades!
              </h3>
              <p className="txt24">
                Has superado la última actividad y has resuelto el caso.
              </p>
              <p className="txt24">
                Pronto sabrás el resultado de tu clasificación en el ranking general.
              </p>
              <div className="mt-3 d-flex align-items-center">
                {/* Botón siguiente */}
                <NextButton
                  navigateTo={ROUTES.FINAL_SCENE}
                  activeScenario={activeScenario}
                  color="green"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <ScenarioBar activeScenario={activeScenario} />
    </div>
  );
}

export default injectIntl(Scenario5Fin);
